module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"prop-header\"><span class=\"prop-label\">Type</span></div>\r\n<div class=\"row\">\r\n	<div class=\"col-md-12\">\r\n		<input type=\"radio\" name=\"connectionType\" value=\"0\" />\r\n		Start\r\n	</div>\r\n	<div class=\"col-md-12\">\r\n		<input type=\"radio\" name=\"connectionType\" value=\"1\" />\r\n		Rollback\r\n	</div>\r\n	<div class=\"col-md-12\">\r\n		<input type=\"radio\" name=\"connectionType\" value=\"2\" />\r\n		Commit\r\n	</div>\r\n</div>\r\n\r\n\r\n\r\n")
  }
  return __output;

}